import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import { ProcessServerService } from "../../../../services/ClientService";

import AttorneySelect from "../../../../components/shared/AttorneySelect";

export default function ProcessServerProfile(
    this: any,
    {
        processServer,
    }: {
        processServer: APIModels.ProcessServer;
    }
) {
    const [updatedProcessServer, setUpdatedProcessServer] =
        useState(processServer);
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setUpdatedProcessServer(processServer);
    }, [processServer]);

    const onSaveClick = () => {
        setSaving(true);
        ProcessServerService.update({
            id: processServer.id || "",
            body: updatedProcessServer,
        }).then(
            (resp) => {
                setSaving(false);
                if (resp.successful === true) {
                    processServer = { ...resp.data };
                } else {
                    setErrorMessage("An error has occurred");
                }
            },
            (error) => {
                setSaving(false);
                setErrorMessage("An error occurred.");
            }
        );
    };

    const onAttorneySelected = (id: string, name: string) => {
        setUpdatedProcessServer({
            ...updatedProcessServer,
            billingAttorneyName: name,
            billingAttorneyID: id,
        });
    };

    const onFirmSelected = (_id: string, _name: string) => {
        console.log("Firm selected");
    };

    return (
        <>
            <div className="card text-left">
                <div className="card-body">
                    <h4 className="mb-3 bg-light p-2">
                        Process Server Profile
                    </h4>
                    <div className="row mb-3">
                        <div className="col-sm-6">
                            <label
                                htmlFor="txtCompanyName"
                                className="form-label"
                            >
                                Company Name
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtCompanyName"
                                    placeholder="Company Name"
                                    aria-describedby="inputGroupPrepend"
                                    value={
                                        updatedProcessServer.companyName || ""
                                    }
                                    onChange={(event) =>
                                        setUpdatedProcessServer({
                                            ...updatedProcessServer,
                                            companyName:
                                                event.currentTarget.value,
                                        })
                                    }
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid company name.
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <label
                                htmlFor="txtContactName"
                                className="form-label"
                            >
                                Contact Name
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtContactName"
                                    placeholder="Contact Name"
                                    aria-describedby="inputGroupPrepend"
                                    value={
                                        updatedProcessServer.contactName || ""
                                    }
                                    onChange={(event) =>
                                        setUpdatedProcessServer({
                                            ...updatedProcessServer,
                                            contactName:
                                                event.currentTarget.value,
                                        })
                                    }
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid contact name.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-sm-6">
                            <label htmlFor="txtEmail" className="form-label">
                                Email
                            </label>
                            <div className="input-group">
                                <input
                                    type="email"
                                    className="form-control"
                                    id="txtEmail"
                                    placeholder="Email"
                                    aria-describedby="inputGroupPrepend"
                                    value={updatedProcessServer.email || ""}
                                    onChange={(event) =>
                                        setUpdatedProcessServer({
                                            ...updatedProcessServer,
                                            email: event.currentTarget.value,
                                        })
                                    }
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid email address.
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <label
                                htmlFor="txtPhoneNumber"
                                className="form-label"
                            >
                                Phone Number
                            </label>
                            <div className="input-group">
                                <input
                                    type="tel"
                                    className="form-control"
                                    id="txtPhoneNumber"
                                    placeholder="Phone Number"
                                    aria-describedby="inputGroupPrepend"
                                    value={
                                        updatedProcessServer.phoneNumber || ""
                                    }
                                    onChange={(event) =>
                                        setUpdatedProcessServer({
                                            ...updatedProcessServer,
                                            phoneNumber:
                                                event.currentTarget.value,
                                        })
                                    }
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid phone number.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-sm-6">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    checked={
                                        updatedProcessServer.active ?? false
                                    }
                                    id="ckActive"
                                    onChange={(e) =>
                                        setUpdatedProcessServer({
                                            ...updatedProcessServer,
                                            active: e.currentTarget.checked,
                                        })
                                    }
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor="ckActive"
                                >
                                    Active
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-sm-12">
                            <label
                                htmlFor="txtContactName"
                                className="form-label"
                            >
                                Current V1 Account For Billing:
                            </label>
                            <div className="input-group">
                                {updatedProcessServer.billingAttorneyName}
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-sm-12">
                            <AttorneySelect
                                onAttorneySelected={onAttorneySelected}
                                onFirmSelected={onFirmSelected}
                            />
                        </div>
                    </div>
                    <div className="text-end">
                        {saving ? (
                            <button
                                className="btn btn-success waves-effect waves-light mt-2"
                                type="button"
                                disabled={true}
                            >
                                <span
                                    className="spinner-border spinner-border-sm me-1"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Saving...
                            </button>
                        ) : (
                            <button
                                className="btn btn-success waves-effect waves-light mt-2"
                                type="submit"
                                onClick={onSaveClick}
                            >
                                <i className="mdi mdi-content-save me-1"></i>
                                Save
                            </button>
                        )}
                        <div>{errorMessage}</div>
                    </div>
                </div>
            </div>
        </>
    );
}
